// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { cityjobs as baseCityjobsTheme } from "@stepstone-genesis/design-tokens";
var cityjobs = extendBaseTheme("cityjobs", baseCityjobsTheme);
export {
  cityjobs
};
